import React from "react";

const Menu = (props)=>{
    return(
        <div id={props.y<100?"menu_ori":"menu_cha"} role={props.y<100?"menu_ori":"menu_cha"} >
            <ul>
                <li><a href="/company">회사소개</a>
                </li>
                <li><a href="#">보유장비 ⅴ</a>
                    <ul>
                        <li><a href="/lathe">선반/CNC</a></li>
                        <li><a href="/mill">머시닝/밀링</a></li>
                        <li><a href="/machine_etc">용접기및기타</a></li>
                    </ul>
                </li>
                <li><a href="#">제품사진 ⅴ</a>
                    <ul>
                        <li><a href="/Shaft_img">펌프샤프트</a></li>
                        <li><a href="/Steel_img">스틸류</a></li>
                        <li><a href="/Sus_img">서스류</a></li>
                        <li><a href="/Al_img">AL류</a></li>
                        <li><a href="/MCetc_img">MC및 기타류</a></li>
                    </ul>
                </li>
                <li><a href="/question">위치 및 문의</a>
                </li>
            </ul>
        </div>

    )
    
}

export default Menu;